export default "__VITE_ASSET__CQzTpLef__"